module.exports = __webpack_public_path__ + "img/joincolor.c102ccf8.png";